import React from "react";

import Card from "react-md/lib/Cards/Card";
import CardText from "react-md/lib/Cards/CardText";

import ProfileInfo from "../components/settings/profile";
import Organizations from "../components/settings/organizations";
import {DebugElement} from "../Atollon/debug";
import {TouchPageHeader, TouchPageHeader_and_content_spaceBetween} from "../AtollonTheme/ReactElements";

const Profile = ({ history }) => {
  return (
    <div className="flex-col">
        <TouchPageHeader title={"Nastavení"}/>
        <TouchPageHeader_and_content_spaceBetween heightPx={50}/>
        <DebugElement text={"src/containers/Profile.js"}/>
      <ProfileInfo />
      <Card>
        <CardText>
          <Organizations history={history} />
        </CardText>
      </Card>
    </div>
  );
};

export default Profile;



// WEBPACK FOOTER //
// ./src/pages/Profile.js